export enum ERowType {
  Link = 'link',
  String = 'string',
  Header = 'header',
  List = 'list',
  Tooltip = 'tooltip',
}

export type TQuestion = {
  id: number;
  question: string;
  answer: TAnswer[];
};

export type TAnswer = TLinkAnswer | TStringAnswer | TListAnswer | TTooltipAnswer;

export type TLinkAnswer = {
  type: ERowType.Link;
  text: string;
  url: string;
};

export type TStringAnswer = {
  type: ERowType.String | ERowType.Header;
  text: string;
};

export type TListAnswer = {
  type: ERowType.List;
  rows: (TLinkAnswer | TStringAnswer)[][];
};

export type TTooltipAnswer = {
  type: ERowType.Tooltip;
  title: string;
};
